import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import AppHeader from '../layout/AppHeader';
import AppSidebar from '../layout/AppSidebar';
import OutlineGenerationNotifier from '../learning/OutlineGenerationNotifier';
import { useAuthStore } from '@/stores/auth-store';
import { useSidebar } from '@/contexts/SidebarContext';

export default function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const { isCollapsed, toggleCollapse } = useSidebar();
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();

  // Use actual user data from auth store
  const userData = {
    name: user?.name || 'User',
    email: user?.email || '',
    avatar: null
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-tutara-dark-mode-bg">
      {/* Background outline generation: turns store state changes into
          actionable toasts (View on success, Retry on transient failure). */}
      <OutlineGenerationNotifier />
      <AppHeader
        onMenuClick={() => setSidebarOpen(!sidebarOpen)}
      />

      <div className="flex">
        <AppSidebar
          isOpen={sidebarOpen}
          isCollapsed={isCollapsed}
          onClose={() => setSidebarOpen(false)}
          onToggleCollapse={toggleCollapse}
          user={userData}
          onLogout={handleLogout}
        />

        <main className={`flex-1 pt-16 transition-all duration-300 overflow-x-hidden ${isCollapsed ? 'lg:pl-16' : 'lg:pl-64'}`}>
          <div className="px-4 sm:px-6 lg:px-8 py-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}